import { useState } from 'react';
import useSignupStore from '../../../store/useSignupStore';
import { IconTrash, IconChevron } from '../../../components/icons';
import AddChildModal, { GENDERS } from './AddChildModal';

const genderLabel = (v) => GENDERS.find((g) => g.value === v)?.label || '';
const genderEmoji = (v) => GENDERS.find((g) => g.value === v)?.emoji || '👦';

const fmtBirthDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export default function KidsStep() {
  const kids = useSignupStore((s) => s.kids);
  const addKid = useSignupStore((s) => s.addKid);
  const removeKid = useSignupStore((s) => s.removeKid);
  const goNext = useSignupStore((s) => s.goNext);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="ob-eyebrow">Your Family</div>
      <h1>Add your little <em>ones</em> 🌱</h1>
      <p className="sub">
        Add your children so we can find age-perfect activities, playdates, and local events for your family.
      </p>

      {kids.length ? (
        <div className="ob-kid-list">
          {kids.map((k) => (
            <div className="ob-kid-row" key={k.id}>
              <span className="ob-kid-face">
                {k.preview ? <img src={k.preview} alt="" /> : genderEmoji(k.gender)}
              </span>
              <div className="info">
                <div className="nm">{k.childName}</div>
                <div className="meta">
                  {genderLabel(k.gender)}
                  {fmtBirthDate(k.birthDate) ? ` · ${fmtBirthDate(k.birthDate)}` : ''}
                </div>
              </div>
              <button className="ob-kid-del" onClick={() => removeKid(k.id)} aria-label={`Remove ${k.childName}`}>
                <IconTrash />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="ob-empty">
          <span className="ob-empty-face">👦</span>
          <div className="ob-empty-title">No kids added yet</div>
        </div>
      )}

      <button type="button" className="ob-add-row" onClick={() => setModalOpen(true)}>
        <span className="ic" />
        <span className="txt">
          <span className="nm">Add your child</span>
          <span className="st">Take less than a minute</span>
        </span>
        <IconChevron className="ob-add-chev" />
      </button>

      <div className="ob-note">
        <span className="ic">i</span>
        We only use your kids' info to keep your class feed, events, and activities relevant.
      </div>

      {/* at least one child is required (Mohit, 30 Sep) */}
      <button className="btn btn-primary btn-primary-full ob-cta" disabled={!kids.length} onClick={goNext}>
        {kids.length ? 'Continue' : 'Add at least one child'}
      </button>

      <AddChildModal open={modalOpen} onClose={() => setModalOpen(false)} onAdd={addKid} />
    </>
  );
}
